module.exports = __webpack_public_path__ + "/bundle/asset/U2_01-048a841398eac2b530b9819bddc785ac.gif";